import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Mapuserdata } from "../../assets/Griddata"; // Import dataset
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { useState, useEffect } from "react";
import { externalgetApi,externaldeleteApi, externalpostApi } from "../../services/external/externalApis";
import { EMPLOYEE_API_05 } from "../../api/ApiModel";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert
} from '@mui/material';
import { CON_STATUS_ACTIVE,CON_STATUS_DELETED } from "../../utils/sys/Constants";
import { useSelector } from 'react-redux';
import DeleteIcon from '@mui/icons-material/Delete';

import SearchAppBar from "../../components/common/search";
import {
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
  STARTDATE,
} from "../../api/ApiModel";


function ViewMapUser() {
  const navigate = useNavigate();
  const [selectedOrderStatusCode, setSelectedOrderStatusCode] = useState(null);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const styles = useStyles(theme);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const [selectedItem, setSelectedItem] = useState(null);
  const { COMPCODE,LOCCODE, GROUPCODE,STS, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [searchText, setSearchText] = useState("");
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const gotToPage = () => {
    navigate("/mapuser");
  };

  const gotoMenuPage1 = () => {
    navigate("/pathToViewItems");
  };

  const gotoMenuPage2 = () => {
    navigate("/mapuser");
  };

 

  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(EMPLOYEE_API_05, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          STS : CON_STATUS_ACTIVE,
        });
        console.log(result);
        setData(result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [COMPCODE, LOCCODE, RESTCODE]);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      USERNAME: item.USERNAME,
      GROUPNAME: item.GROUPNAME,
      USERGROUP: item.USERGROUP,
     
      STARTDATE: item.STARTDATE,
     
    }));
  };



  const handleDelete = async () => {
    if (selectedItem) {
      const payload = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        ACTSTS: CON_STATUS_DELETED,
        USERNAME: selectedItem.USERNAME,
          USERGROUP: String(selectedItem.USERGROUP),
          STARTDATE: selectedItem.STARTDATE,
        locdate: String(new Date().toISOString().split("T")[0]),
        delsts: CON_STATUS_DELETED,
        Enuser: USERNAME,
      };
      try {
        await externalpostApi(EMPLOYEE_API_05, payload);

        // Update filteredData after successful deletion
        setFilteredData((prev) => prev.filter((item) => item.USERNAME !== selectedItem.USERNAME));

        setSnackbarMessage(`${selectedItem.USERNAME} deleted successfully!`);
        setOpenSnackbar(true);
      } catch (error) {
        setSnackbarMessage("Failed to delete the selected item.");
        setOpenErrorSnackbar(true);
      } finally {
        handleClose(); // Close the dialog
      }
    }
  };

  const handleItemClick = (username) => {
    const item = filteredData.find((item) => item.USERNAME === username);
    setSelectedItem(item);
    setOpen(true);
  };
  

  const menuItems = [
    {
      text: "Remove",
      icon: <DeleteIcon />,
      onClick: (USERNAME) => handleItemClick(USERNAME, "Delete"), // Correctly pass USERNAME
    },
  ];
  
 
  

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) =>
        item.GROUPNAME.toLowerCase().includes(searchText.toLowerCase()) ||
        item.USERNAME.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data); // Show all data if no searchText or data is empty
    }
  }, [searchText, data]);
  

  const handleSearchChange = (event) => {
    setSearchText(event.target.value); // Update searchText when typing in TextField
  };

  const handleClickOpen = (USERNAME) => {
    setSelectedOrderStatusCode(USERNAME); // Set the selected GRNNO
    setOpen(true); // Open the confirmation dialog
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrderStatusCode(null);
  };
  
  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
    setOpenErrorSnackbar(false);
  };
  const rows = filteredData
    ? filteredData.map((item, index) => ({
        id: index + 1,
        USERGROUP: item.USERGROUP,
        USERNAME: item.USERNAME,
        GROUPNAME: item.GROUPNAME,
        STARTDATE: item.STARTDATE,
      }))
    : [];


  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover" href="/">
                  Home
                </Link>
                <Link underline="hover">Employee</Link>
                <Link underline="hover">Map user</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
            <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
              >
            <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => gotToPage()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
      <ViewData
        columns={Mapuserdata.columns}
        rows={rows}
        menuItems={menuItems}
        tabletitle={Mapuserdata.name}
       gridid="USERNAME"
      />
      )}
    <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Confirm Remove</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove {selectedItem?.USERNAME}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}   sx={{
            backgroundColor: theme.palette.system.danger,
            color: theme.palette.background.paper,
            textTransform: "capitalize",
            borderRadius: 2,
            width: "100px",
            px: 3,
            "&:hover": {
              backgroundColor: theme.palette.system.danger,
            },
          }}
          color="secondary" >No</Button>
          <Button onClick={handleDelete}  sx={{
            background: theme.palette.primary.main,
            color: theme.palette.text.buttontxt,
            textTransform: "capitalize",
            borderRadius: 2,
            width: "100px",
            px: 3,
            "&:hover": {
              background: theme.palette.primary.main,
            },
          }} color="secondary">Yes</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
      id="MUS_sb1" 
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert id="MUS_al1"  onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Snackbar
       id="MUS_sb2" 
        open={openErrorSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert  id="MUS_al2"  onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ViewMapUser;
